<template>
  <a-modal
    centered
    v-model="visible"
    @cancel="onCancel"
    @ok="onSubmit"
    :maskClosable="false"
    style="min-width:1250px"
  >
    <template slot="footer">
      <a-radio-group
        name="radioGroup"
        v-model="isOnlyPayment"
        button-style="solid"
        style="float:left"
      >
        <a-radio-button :value="1">
          付款并结账
        </a-radio-button>
        <a-radio-button :value="2">
          仅付款
        </a-radio-button>
      </a-radio-group>
      <a-button
        class="cancel-btn ml"
        style="float:left"
        v-if="info.IsOnlinePay"
        @click="getOrderQuery"
        >微信客人自结记录</a-button
      >
      <a-button @click="onCancel">取消</a-button>
      <a-button type="primary" @click="onSubmit" :loading="loading"
        >确定</a-button
      >
    </template>
    <template slot="title">
      结账
      <!-- <span v-if="info.Discount > 0" style="float: right; margin-right: 80px; ">
        <a-tag color="cyan" style="font-size:16px">
          当前折扣：{{ info.Discount }} 折
        </a-tag>
      </span> -->
    </template>
    <a-spin :spinning="spinning">
      <a-row :gutter="10">
        <a-col :span="6">
          <div class="title">
            桌台
            <a-checkbox
              class="fr"
              :checked="checkAll"
              @change="onCheckAllChange"
              >全选</a-checkbox
            >
          </div>
          <div class="item-wrapper table-list-wrapper table-info-section">
            <a-checkbox-group v-model="checkedList" @change="onChange">
              <template v-for="item in openTables">
                <!-- <a-checkbox
                  :key="item.TableId"
                  disabled
                  v-if="item.OrderStatus == 2"
                >
                  {{ item.TableName }}
                  <a-tag
                    :color="
                      item.OrderStatus == 2
                        ? '#87d068'
                        : item.OrderStatus == 12
                        ? '#f80'
                        : '#f50'
                    "
                    >{{ item.OrderStatusName }}</a-tag
                  >
                </a-checkbox> -->
                <div
                  class="complete-table"
                  :class="{ active: selectedKey.includes(item.TableId) }"
                  v-if="item.OrderStatus == 2"
                  :key="item.TableId"
                  @click="onSelectTable(item)"
                >
                  {{ item.TableName }}
                  <a-tag
                    :color="
                      item.OrderStatus == 2
                        ? '#87d068'
                        : item.OrderStatus == 12
                        ? '#f80'
                        : '#f50'
                    "
                    >{{ item.OrderStatusName }}</a-tag
                  >
                  <a-icon type="check" class="check" />
                </div>
                <a-checkbox v-else :key="item.TableId" :value="item.TableId">
                  {{ item.TableName }}
                </a-checkbox>
              </template>
            </a-checkbox-group>
          </div>
        </a-col>
        <a-col :span="18">
          <div class="title">
            财务信息
            <span class="fr"
              >总计：
              <span class="total-amount"> ￥{{ totalCosume }}</span>
            </span>
          </div>
          <div class="item-wrapper table-info-section">
            <data-grid
              ref="accountTable"
              size="small"
              :columns="columns"
              v-model="orderFoodList"
              :pagination="false"
              :props="accountTableProps"
            >
            </data-grid>
          </div>
        </a-col>
      </a-row>
      <div>
        <div class="title pay-title">
          付款信息
          <a-button type="primary" icon="plus" size="small" @click="addPayItem"
            >增加收款</a-button
          >
          <div class="pay-summary">
            <span class="pay-item">
              <a-popconfirm
                title="确定取消折扣吗?"
                ok-text="确定"
                cancel-text="取消"
                @confirm="cancelDiscount"
                v-if="Number(info.Discount) > 0"
              >
                <a-button size="small" class="cancel-btn" icon="stop">
                  取消折扣
                </a-button>
              </a-popconfirm>
              <a-button
                size="small"
                type="primary"
                icon="percentage"
                @click="addDiscount"
                v-else
              >
                折扣
              </a-button>
              <span v-if="Number(info.Discount) > 0">
                当前折扣：
                <span class="total-amount">{{ info.Discount }} 折</span>
              </span>
            </span>
            <span class="pay-item">
              <a-popconfirm
                title="确定取消抹零吗?"
                ok-text="确定"
                cancel-text="取消"
                @confirm="cancelFreeRemnant"
                v-if="Math.abs(info.FreeRemnantAmount) > 0"
              >
                <a-button size="small" class="cancel-btn" icon="stop">
                  取消抹零
                </a-button>
              </a-popconfirm>
              <a-button
                icon="tag"
                size="small"
                type="primary"
                @click="addFreeRemnant"
                v-else
              >
                抹零
              </a-button>
              <span v-if="Math.abs(info.FreeRemnantAmount) > 0">
                抹零金额：
                <span class="total-amount">￥{{ info.FreeRemnantAmount }}</span>
              </span>
            </span>
            <span
              >显示已冲账账务：<a-switch v-model="showAllPays"></a-switch
            ></span>
          </div>
        </div>
        <div class="item-wrapper pay-list-info">
          <a-row>
            <a-col :span="3" class="pay-tag-list">
              <span
                class="pay-tag"
                :class="{ active: selectPayId == payway.Id }"
                v-for="payway in select.restaurantpayway"
                :key="payway.Id"
                @click="choosePayId(payway.Id)"
              >
                {{ payway.Text }}
              </span>
            </a-col>
            <a-col :span="21" class="consume-list">
              <a-table
                :data-source="payList"
                :scroll="{ x: false, y: 115 }"
                :pagination="false"
                size="small"
                :bordered="false"
                style="padding-bottom: 5px;min-height: 145px;"
              >
                <a-table-column
                  width="160px"
                  key="AccountItemId"
                  title="付款方式"
                  data-index="AccountItemId"
                >
                  <template slot-scope="text, record, index">
                    <a-select
                      v-model="record.AccountItemId"
                      style="width:100%;margin-bottom: 3px;"
                      @change="onChangePayWay($event, record, index)"
                    >
                      <a-select-option
                        v-for="item in select.restaurantpayway"
                        :key="item.Id"
                        :value="item.Id"
                        :title="item.Text"
                        >{{ item.Text }}</a-select-option
                      >
                    </a-select>
                  </template>
                </a-table-column>
                <a-table-column
                  key="Money"
                  title="金额"
                  data-index="Money"
                  width="100px"
                >
                  <template slot-scope="text, record">
                    <a-input-number v-model="record.Money" />
                  </template>
                </a-table-column>
                <a-table-column
                  key="BillNo"
                  title="单据号"
                  data-index="BillNo"
                  width="150px"
                >
                  <template slot-scope="text, record">
                    <a-input v-model="record.BillNo" />
                  </template>
                </a-table-column>
                <a-table-column
                  key="TargetName"
                  title="挂账客户/会员"
                  data-index="TargetName"
                  width="150px"
                >
                  <template slot-scope="text, record">
                    <a-input :value="record.TargetName" disabled />
                  </template>
                </a-table-column>
                <a-table-column
                  width="110px"
                  key="TableId"
                  title="桌台"
                  data-index="TableId"
                >
                  <template slot-scope="text, record">
                    <a-select v-model="record.TableId" style="width:100%; ">
                      <a-select-option
                        v-for="item in openTables"
                        :key="item.TableId"
                        :value="item.TableId"
                        :title="item.TableName"
                        >{{ item.TableName }}</a-select-option
                      >
                    </a-select>
                  </template>
                </a-table-column>
                <a-table-column key="Remark" title="备注" data-index="Remark">
                  <template slot-scope="text, record">
                    <a-input v-model="record.Remark" />
                  </template>
                </a-table-column>
                <a-table-column key="action" title="操作" width="70px">
                  <template slot-scope="text, record, index">
                    <a-button
                      type="link"
                      icon="minus-circle"
                      style="color:#f00;font-size:20px"
                      @click="delRow(index)"
                    ></a-button>
                  </template>
                </a-table-column>
              </a-table>
              <data-grid
                ref="consumeTable"
                size="small"
                :columns="payColumns"
                v-model="payments"
                :pagination="false"
                :props="props"
              >
              </data-grid>
              <div class="pay-summary-box">
                <span>
                  消费金额:
                  <span class="total-amount">￥{{ info.TotalAmount }}</span>
                </span>
                <span style="float: left; ">
                  已收金额:
                  <span class="total-amount">￥{{ info.PayAmount }}</span>
                </span>
                <span>
                  折扣金额:
                  <span class="total-amount">￥{{ info.DiscountAmount }}</span>
                </span>
                <span>
                  抹零金额:
                  <span class="total-amount"
                    >￥{{ info.FreeRemnantAmount }}</span
                  >
                </span>
                <span>
                  {{
                    Number(info.UnPayAmount) >= 0 ? "待收金额:" : "待退金额:"
                  }}
                  <span
                    class="total-amount"
                    style="font-size: 18px;letter-spacing: 0;"
                    >￥{{ info.UnPayAmount }}</span
                  >
                </span>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
    </a-spin>
    <a-modal
      centered
      :maskClosable="false"
      :title="passWordTitle"
      v-model="passWordModal"
      width="40%"
      @ok="onSubmitPassWord"
      @cancel="cancelPassWord"
      :confirmLoading="passLoading"
    >
      <div style="text-align: center;">
        密码:<a-input
          v-model="passWord"
          type="password"
          style="width: 70%;margin-left: 10px;"
        ></a-input>
      </div>
    </a-modal>
    <CustomerModal
      ref="CustomerModal"
      @cancel="cancelSelCustomer"
      @submit="submitSelCustomer"
    ></CustomerModal>
    <Discount ref="Discount" @submit="getDiscountData"></Discount>
    <FreeRemnant ref="FreeRemnant" @submit="getDetail"></FreeRemnant>
    <CheckInRoomList
      ref="CheckInRoomList"
      :defaultItem="defaultItem"
      @cancel="cancelSelRoom"
      @submit="getRoomInfoId"
    ></CheckInRoomList>
    <PayResult ref="PayResult"></PayResult>
  </a-modal>
</template>
<script>
import { DataGrid } from "@/components/dataGrid";
import { getSelectData, accAdd, accSub } from "@/utils/common";
import { BankOrScanPayModal } from "@/views/orderManage/orderComponent/funtion.js";
import { MemberListModal } from "@/views/roommanage/index.js";
import CustomerModal from "./CustomerModal";
import Discount from "./Discount";
import FreeRemnant from "./FreeRemnant";
import CheckInRoomList from "./CheckInRoomList";
import md5 from "js-md5";
import "./settle.less";
import PayResult from "./PayResult";
export default {
  components: {
    DataGrid,
    CustomerModal,
    Discount,
    CheckInRoomList,
    FreeRemnant,
    PayResult
  },
  data() {
    return {
      id: "",
      visible: false,
      spinning: false,
      info: {},
      props: {
        scroll: {
          x: false,
          y: "calc(50vh - 252px)"
        }
      },
      accountTableProps: {
        scroll: {
          x: false,
          y: "calc(40vh - 140px)"
        }
      },
      columns: [
        {
          title: "桌台",
          width: 130,
          dataIndex: "TableName"
        },
        {
          title: "账务名称",
          width: 200,
          dataIndex: "AccountItemName"
        },
        {
          title: "单价",
          width: 80,
          dataIndex: "UnitPrice"
        },
        {
          title: "数量",
          width: 80,
          dataIndex: "Quantity"
        },
        {
          title: "总价",
          width: 100,
          dataIndex: "TotalPrice"
        },
        {
          title: "折扣金额",
          width: 80,
          dataIndex: "DiscountPrice"
        },
        {
          title: "折后价",
          dataIndex: "FinalPrice"
        }
      ],
      payColumns: [
        {
          title: "付款方式",
          width: 160,
          dataIndex: "AccountItemName"
        },
        {
          title: "金额",
          width: 100,
          dataIndex: "TotalPrice"
        },
        {
          title: "单据号",
          width: 150,
          dataIndex: "BillNo"
        },
        {
          title: "挂账客户/会员",
          width: 150,
          dataIndex: "TargetName"
        },
        {
          title: "桌台",
          width: 110,
          dataIndex: "TableName"
        },
        {
          title: "备注",
          dataIndex: "Remark"
        },
        {
          title: "创建时间",
          width: 150,
          dataIndex: "CreationTime"
        },
        {
          title: "操作",
          dataIndex: "Id",
          width: 70,
          customRender: (text, record) => {
            const revoke = {
              click: () => {
                this.$post("RMS_Revoke", { AccountId: record.Id }).then(() => {
                  this.$message.success("操作成功");
                  this.getDetail();
                });
              }
            };
            if (
              (record.TableStatus == 1 || record.TableStatus == 12) &&
              record.AccountSign != 1
            ) {
              return (
                <a-button type="link" size="small" {...{ on: revoke }}>
                  冲账
                </a-button>
              );
            } else {
              return "";
            }
          }
        }
      ],
      // orderFoodList: [],
      checkedList: [],
      openTables: [],
      payList: [],
      select: {},
      showAllPays: false,
      defaultItem: {},
      passWordTitle: "",
      passWordModal: false,
      passWord: "",
      passLoading: false,
      currentPayItem: {},
      selectedKey: [],
      loading: false,
      isOnlyPayment: 1,
      selectPayId: ""
      // paysIndex: 0
    };
  },
  created() {
    getSelectData(["restaurantpayway", "offercreditcustomer"]).then(res => {
      this.select = res;
      this.select.restaurantpayway = this.select.restaurantpayway.filter(
        el =>
          !(
            el &&
            el.Data &&
            (el.Data.Attributes & 8192) > 0 &&
            el.Text.includes("会员卡")
          )
      );
    });
    this.$post("Room_GetDefaultTime", {}).then(res => {
      res.Data.SystemConstList.forEach(item => {
        this.defaultItem[item.Code] = item.Value;
      });
    });
  },
  computed: {
    orderFoodList() {
      const data = this.openTables.filter(el =>
        this.checkedList.includes(el.TableId)
      );
      data.forEach(el => {
        let total = 0;
        el.DishAccounts.forEach(item => {
          total = accAdd(total, item.FinalPrice);
        });
        el.needToPay = total;
      });
      let accounts = [];
      data.forEach(el => {
        accounts = accounts.concat(el.DishAccounts);
      });
      if (this.selectedKey && this.selectedKey.length) {
        const otherTable = this.openTables.filter(el =>
          this.selectedKey.includes(el.TableId)
        );
        otherTable.forEach(el => {
          accounts = accounts.concat(el.DishAccounts);
        });
      }

      return accounts;
    },
    payments() {
      if (this.info && this.info.Payments && this.info.Payments.length) {
        if (this.showAllPays) {
          return this.info.Payments;
        } else {
          return this.info.Payments.filter(el => el.AccountSign != 1);
        }
      }
      return [];
    },
    totalCosume() {
      let total = 0;
      this.orderFoodList.forEach(el => {
        total = accAdd(total, el.FinalPrice);
      });
      return total;
    },
    totalPayAmount() {
      let total = 0;
      const paymentList = this.payList.filter(el => Number(el.Money) != 0);
      paymentList.forEach(el => {
        total = accAdd(total, el.Money);
      });
      return total;
    },
    checkAll() {
      return (
        this.checkedList.length ===
        this.openTables.filter(el => el.OrderStatus != 2 && el.OrderStatus != 4)
          .length
      );
    }
    // needToPayAmount() {
    //   const need = accSub(this.info.FinalAmount, this.info.PayAmount);
    //   return accSub(need, this.info.PayAmount);
    // }
  },
  methods: {
    getOrderQuery() {
      this.$refs.PayResult.show(this.id);
    },
    updatePayResult() {
      this.getDetail().then(res => {
        if (res.Status == 2 && res.IsOnlinePay) {
          this.$info({
            title: "订单已结账",
            content: "查询结果为微信支付成功，该订单已自动执行结账处理",
            onOk() {}
          });
        }
      });
    },
    choosePayId(id) {
      this.selectPayId = id == this.selectPayId ? "" : id;
      // this.payList[0].AccountItemId = id;
      if (this.selectPayId && this.payList && this.payList.length) {
        this.onChangePayWay(id, this.payList[0], 0);
      }
    },
    onSelectTable(item) {
      this.selectedTable = item;
      if (this.selectedKey.includes(item.TableId)) {
        this.selectedKey = this.selectedKey.filter(el => el != item.TableId);
      } else {
        this.selectedKey.push(item.TableId);
      }
    },
    show(id) {
      this.id = id;
      this.visible = true;
      this.reset();
      this.getDetail();
    },
    reset() {
      this.allAccounts = [];
      this.showAllPays = false;
      this.isOnlyPayment = 1;
      // this.orderFoodList = [];
      this.checkedList = [];
      this.openTables = [];
      this.selectPayId = "";
      this.payList = [
        {
          key: "1",
          AccountItemId: "",
          AccountItemName: "",
          RoomInfoId: "0",
          Money: "0",
          BillNo: "",
          Remark: "",
          TargetName: "",
          TableId: ""
        }
      ];
    },
    getDetail() {
      return new Promise((resolve, reject) => {
        this.spinning = true;
        this.$post("Rest_GetOrderDetail", { Id: this.id })
          .then(res => {
            this.info = res.Data;
            this.spinning = false;
            this.setData();
            resolve(res.Data);
          })
          .catch(() => {
            this.spinning = false;
            reject();
          });
      });
    },
    setData() {
      this.openTables = this.info.DishTables;
      this.checkedList = this.openTables
        .filter(el => el.OrderStatus != 2 && el.OrderStatus != 4)
        .map(v => v.TableId);
      this.payList[0].Money = this.info.UnPayAmount;
      this.payList[0].TableId = this.checkedList[0];
      this.payList[0].BillNo = this.openTables.find(
        el => el.TableId == this.checkedList[0]
      ).TableName;
      if (this.info.MemberCardId) {
        const accountItem = this.select.restaurantpayway.find(item => {
          return (
            (item.Data && item.Data.Attributes & 4096) > 0 &&
            item.Text.includes("会员卡")
          );
        });
        this.payList[0].AccountItemId = accountItem ? accountItem.Id : "";
        this.payList[0].MemberCardId = this.info.MemberCardId;
        this.payList[0].Password = "";
        this.payList[0].TargetName = this.info.MemberName;
      } else if (this.info.CustomerId) {
        this.payList[0].CustomerId = this.info.CustomerId;
      }
    },
    addDiscount() {
      this.$refs.Discount.show(this.info);
    },
    addFreeRemnant() {
      this.$refs.FreeRemnant.show(this.info);
    },
    cancelFreeRemnant() {
      this.$post("CancelFreeRemnant", {
        Id: this.info.Id
      })
        .then(() => {
          this.$message.success("操作成功");
          this.getDetail();
        })
        .catch(() => {});
    },
    getDiscountData(data) {
      this.info = data;
      this.openTables = this.info.DishTables;
      // this.setData();
      this.payList[0].Money = this.info.UnPayAmount;
    },
    getRoomInfoId(roomInfoId, result, item) {
      item.RoomInfoId = roomInfoId;
      item.TargetName = result.GuestName;
      item.MemberCardId = "0";
    },
    cancelDiscount() {
      this.$post("RMS_Discount", {
        Id: this.info.Id,
        Discount: 0,
        IsPreview: false
      }).then(res => {
        this.$message.success("操作成功");
        this.getDiscountData(res.Data);
      });
    },
    addPayItem() {
      const row = {
        key: new Date().getTime() + parseInt(Math.random() * 1000),
        AccountItemId: "",
        AccountItemName: "",
        Money: accSub(this.info.UnPayAmount, this.totalPayAmount),
        BillNo: "",
        Remark: "",
        TargetName: "",
        TableId: this.checkedList[0]
      };
      this.payList.push(row);
    },
    delRow(index) {
      this.payList.splice(index, 1);
    },
    cancelSelCustomer(record) {
      record.AccountItemId = "";
      record.CustomerId = "0";
      record.TargetName = "";
    },
    cancelSelRoom(record) {
      record.AccountItemId = "";
      record.RoomInfoId = "0";
      record.TargetName = "";
    },
    submitSelCustomer(record, data) {
      record.CustomerId = data.Id;
      record.TargetName = data.Name;
    },
    onSubmitPassWord() {
      const _this = this;
      let passWord = md5(this.passWord.trim());
      this.passLoading = true;
      this.$post("MemberVerificationPassword", {
        MemberCardId: this.currentPayItem.MemberCardId,
        Password: passWord
      })
        .then(() => {
          _this.currentPayItem.Password = passWord;
          _this.passWordModal = false;
          _this.passLoading = false;
        })
        .catch(() => {
          _this.passLoading = false;
        });
    },
    cancelPassWord() {
      this.currentPayItem.AccountItemId = "";
      this.currentPayItem.TargetName = "";
      this.currentPayItem.Password = "";
      this.passWordModal = false;
    },
    onChangePayWay(val, record, index) {
      record.AccountItemId = val;
      const item = this.select.restaurantpayway.find(el => el.Id == val);
      this.resetAccountItem(record);
      if (item.Data && item.Data.Attributes) {
        if ((item.Data.Attributes & 64) > 0) {
          this.$refs.CheckInRoomList.show(record); //转客房
        } else if ((item.Data.Attributes & 2) > 0) {
          this.$refs.CustomerModal.show(record); //选择挂账客户
        } else if (
          ((item.Data.Attributes & 4096) > 0 ||
            (item.Data.Attributes & 8192) > 0) &&
          item.Text.includes("会员卡")
        ) {
          if (
            index == 0 &&
            this.info.MemberCardId &&
            this.info.MemberCardId != "0"
          ) {
            record.MemberCardId = this.info.MemberCardId;
            record.Password = "";
            record.TargetName = this.info.MemberName;
          } else {
            MemberListModal({
              option: {
                defaultItem: this.defaultItem
              },
              update: data => {
                this.passWordTitle =
                  "请输入 " + data.Name + "(卡:" + data.CardNo + ") 密码";
                record.MemberCardId = data.Id;
                record.TargetName = data.Name;
                this.currentPayItem = record;
                this.passWordModal = true;
                this.passWord = "";
              },
              cancel: () => {
                record.AccountItemId = "";
                record.MemberCardId = "0";
                record.TargetName = "";
              }
            });
          }
        } else if (
          ((item.Data.Attributes & 131072) > 0 ||
            (item.Data.Attributes & 262144) > 0) &&
          this.defaultItem.HuiyiPos == "1"
        ) {
          let payTitle = "",
            payType = "";
          if ((item.Data.Attributes & 131072) > 0) {
            payTitle = "银行卡消费";
            payType = 1;
          } else if ((item.Data.Attributes & 262144) > 0) {
            payTitle = "扫码消费";
            this.payType = 2;
          }
          BankOrScanPayModal({
            title: payTitle,
            payType: payType,
            option: record,
            PaySign: 1,
            defaultItem: this.defaultItem,
            orderId: this.id,
            orderNo: this.info.No,
            update: () => {
              record.AccountItemId = "";
              this.getDetail();
            }
          });
        } else if ((item.Data.Attributes & 2097152) > 0) {
          const payConfig = JSON.parse(this.defaultItem.AllInPayConfig);
          if (payConfig.status == 1) {
            const tit =
              (item.Data.Attributes & 2097152) > 0
                ? "通联扫码"
                : "通联扫码预授权";
            const payApi =
              (item.Data.Attributes & 2097152) > 0
                ? "/api/AllInPayQrPay/Pay"
                : "/api/AllInPayPreQrPay/Pay";
            const payType = (item.Data.Attributes & 2097152) > 0 ? 1 : 3;

            BankOrScanPayModal({
              title: tit,
              hasAuthCode: true,
              payType: payType,
              payApi: payApi,
              option: record,
              PaySign: 4,
              defaultItem: this.defaultItem,
              orderId: this.id,
              orderNo: this.info.No,
              update: () => {
                record.AccountItemId = "";
                this.getDetail();
              }
            });
          }
        }
        // else {
        //   // record.TargetName = "";
        //   // record.MemberCardId = "0";
        //   // record.CustomerId = "0";
        //   // record.Password = "";
        //   // record.RoomInfoId = "0";
        //   this.resetAccountItem(record);
        // }
      }
    },
    resetAccountItem(record) {
      record.TargetName = "";
      record.MemberCardId = "0";
      record.CustomerId = "0";
      record.Password = "";
      record.RoomInfoId = "0";
    },
    onCheckAllChange(e) {
      Object.assign(this, {
        checkedList: e.target.checked
          ? this.openTables
              .filter(el => el.OrderStatus != 2 && el.OrderStatus != 4)
              .map(v => v.TableId)
          : []
      });
    },
    onChange() {
      if (this.payList && this.payList.length) {
        this.payList[0].TableId =
          this.checkedList && this.checkedList.length
            ? this.checkedList[0]
            : "";
      }
    },
    onCancel() {
      this.visible = false;
      this.$emit("update");
    },
    onSubmit() {
      const paymentList = this.payList.filter(el => Number(el.Money) != 0);
      if (this.checkedList && !this.checkedList.length) {
        this.$message.error("请选择结账桌台");
        return false;
      }
      const len = this.openTables.filter(el => el.OrderStatus != 2).length;
      if (
        this.checkedList.length == len &&
        Number(this.info.UnPayAmount) != 0 &&
        this.isOnlyPayment != 2
      ) {
        if (!paymentList || !paymentList.length) {
          this.$message.error("请添加付款项并填写金额");
          return false;
        }
      } else if (
        this.isOnlyPayment == 2 &&
        (!paymentList || !paymentList.length)
      ) {
        this.$message.error("请添加付款项并填写金额");
        return false;
      }
      if (paymentList && paymentList.length) {
        const isValid = paymentList.every(el => {
          if (Number(el.Money) != 0 && !el.AccountItemId) {
            return false;
          }
          return true;
        });
        if (!isValid) {
          this.$message.error("金额不为0,必须选择付款方式");
          return false;
        }
        paymentList.forEach((el /*, index*/) => {
          el.TableId = el.TableId ? el.TableId : this.checkedList[0];
          const table = this.openTables.find(
            item => item.TableId == el.TableId
          );
          el.TableName = table ? table.TableName : "";
        });
        let passFlag = true;
        for (let i = 0; i < paymentList.length; i++) {
          const el = paymentList[i];
          if (el.MemberCardId && el.MemberCardId != "0" && !el.Password) {
            this.passWordModal = true;
            this.passWord = "";
            this.passWordTitle = "请输入会员卡 【" + el.TargetName + "】 密码";
            this.currentPayItem = el;
            passFlag = false;
            break;
          }
        }
        if (!passFlag) {
          return false;
        }
        if (
          Number(this.totalPayAmount) != Number(this.info.UnPayAmount) &&
          this.checkedList.length == len &&
          this.isOnlyPayment != 2
        ) {
          this.$message.error("付款金额与待付金额不一致");
          return false;
        }
      }
      const json = {
        OrderId: this.id,
        No: this.info.No,
        TableIds: this.checkedList,
        Payments: paymentList,
        IsOnlyPayment: this.isOnlyPayment == 2
      };
      this.loading = true;
      this.$post("RMS_Settle", json)
        .then(() => {
          this.$message.success("操作成功");
          this.$emit("update");
          this.visible = false;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped></style>
